// extracted by mini-css-extract-plugin
module.exports = {"root":"InnerCard_root__2jGi7","title":"InnerCard_title__aaUk8"};